import { render, staticRenderFns } from "./RequestAndCompleint.vue?vue&type=template&id=040f5e31&"
import script from "./RequestAndCompleint.vue?vue&type=script&lang=js&"
export * from "./RequestAndCompleint.vue?vue&type=script&lang=js&"
import style0 from "./RequestAndCompleint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports